(() => {
  if (window.__bhaktiWholeRupeePrices) return;
  window.__bhaktiWholeRupeePrices = true;

  const SKIP_TAGS = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA', 'INPUT', 'SELECT', 'OPTION', 'CODE', 'PRE']);
  const PRICE_CONTEXT = [
    '.price',
    '[class*="price"]',
    '[class*="money"]',
    '[data-price]',
    '[data-product-price]',
    '[data-cart-subtotal]',
    '[data-cart-total]',
    '.totals',
    '.cart-item__totals',
    '.bhakti-cod-price',
    '.bhakti-divine-sticky__price',
    '.bhakti-sticky-atc__price'
  ].join(',');

  const stripCurrencyDecimals = (value) => {
    if (!value || !value.includes('.00')) return value;

    return value
      .replace(/(₹\s*[\d,]+)\.00\b/g, '$1')
      .replace(/((?:Rs\.?|INR)\s*[\d,]+)\.00\b/gi, '$1')
      .replace(/([\d,]+)\.00(\s*INR\b)/gi, '$1$2');
  };

  const isPriceContext = (element) => {
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return false;
    try {
      return Boolean(element.closest(PRICE_CONTEXT));
    } catch (_) {
      return false;
    }
  };

  const formatTextNode = (node) => {
    const parent = node.parentElement;
    if (!parent || SKIP_TAGS.has(parent.tagName)) return;

    const current = node.nodeValue;
    if (!current || !current.includes('.00')) return;

    let next = stripCurrencyDecimals(current);
    if (next === current && isPriceContext(parent)) {
      next = current.replace(/\b(\d[\d,]*)\.00\b/g, '$1');
    }

    if (next !== current) node.nodeValue = next;
  };

  const formatAttributes = (element) => {
    if (!element || element.nodeType !== Node.ELEMENT_NODE || SKIP_TAGS.has(element.tagName)) return;

    ['aria-label', 'title'].forEach((attribute) => {
      if (!element.hasAttribute(attribute)) return;
      const current = element.getAttribute(attribute) || '';
      const next = stripCurrencyDecimals(current);
      if (next !== current) element.setAttribute(attribute, next);
    });
  };

  const formatRoot = (root) => {
    if (!root) return;

    if (root.nodeType === Node.TEXT_NODE) {
      formatTextNode(root);
      return;
    }

    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) return;

    if (root.nodeType === Node.ELEMENT_NODE) formatAttributes(root);

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.nodeType === Node.TEXT_NODE) formatTextNode(node);
      else formatAttributes(node);
    }
  };

  const boot = () => {
    if (!document.body) return;

    formatRoot(document.body);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') {
          formatTextNode(mutation.target);
          return;
        }

        mutation.addedNodes.forEach(formatRoot);
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });

    document.addEventListener('shopify:section:load', (event) => {
      formatRoot(event.target);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
